<template>
  <div class="news">
    <div
      class="news-card"
      v-for="(news, index) in news"
      :key="index"
      :class="{ first: index === 0 }"
      @click="goDetail(news.id)"
    >
      <div class="news-image">
        <img :src="news.url" alt="" />
      </div>
      <div class="news-info">
        <div class="news-date">{{ news.date }}</div>
        <div class="news-title">{{ news.title }}</div>
        <div class="news-description">{{ news.description }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      news: [
        {
          id: 3,
          date: "2024.10.22",
          title: this.$t("bzzd4"),
          description: this.$t("bzzd2"),
          url: require("@/assets/images/bzzd3.png"),
        },
        {
          id: 1,
          date: "2017.03.22",
          title: this.$t("bzzd1"),
          url: require("@/assets/images/bzzd1.png"),
        },
        {
          id: 2,
          date: "2016.03.31",
          title: this.$t("bzzd3"),
          description: "",
          url: require("@/assets/images/bzzd2.png"),
        },
      ],
    };
  },
  methods: {
    goDetail(id) {
      this.$router.push("/standards/detail?id=" + id);
    },
  },
};
</script>

<style scoped lang="scss">
.news {
  margin-top: 24px;
}
.news-card {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 58px 0;
  &.first {
    padding-top: 0;
  }
  cursor: pointer;
  &:hover {
    .news-image {
      width: 40%;
    }
    border-bottom: 1px solid rgba(255, 255, 255, 0.22);
  }
}

.news-image {
  width: 38%;
  margin-right: 60px;
  color: #fff;
  img {
    width: 100%;
    height: auto;
  }
}

.news-info {
  flex: 1;
  padding: 10px;
  text-align: left;
}

.news-date {
  font-weight: bold;
  color: #fefefe;
  font-size: 24px;
  font-style: italic;
}

.news-title {
  margin-top: 3%;
  font-weight: bold;
  font-size: 32px;
  margin-bottom: 8%;
}

.news-description {
  font-size: 14px;
  margin-top: 5px;
  font-weight: 400;
  font-size: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 限制行数 */
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 45px;
  text-indent: 2em;
}
</style>